module.exports = __webpack_public_path__ + "img/logo-blue.f1d331c4.svg";